// import { useNavigate, useParams } from "react-router-dom";
// import CloseIcon from "@mui/icons-material/Close";

// import MainContainer from "../../layout/MainContainer";

// import { Button, IconButton, Input, TextField } from "@mui/material";
// import { useState } from "react";

// const AddBranch = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [image, setImage] = useState("");

//   const handleImageUpload = async (
//     event: React.ChangeEvent<HTMLInputElement>
//   ) => {
//     const files = event.target.files;
//     const file = files?.length ? files[0] : null;

//     if (!file) {
//       setImage("");
//       return;
//     }

//     // Generate a temporary URL for preview
//     const imageUrl = URL.createObjectURL(file);
//     setImage(imageUrl);
//   };

//   return (
//     <MainContainer>
//       <div className="main_title fdx">
//         <div>
//           <h1>{id ? "Edit" : "Add"} Branch</h1>
//           <p>
//             <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
//             <span onClick={() => navigate("/manage-branches")}>
//               Branches
//             </span>{" "}
//             - {id ? "Edit" : "Add"} Branch
//           </p>
//         </div>
//         <div className="right_s align_right">
//           <Button className="btn btn_blue" onClick={() => navigate(-1)}>
//             Back
//           </Button>
//         </div>
//       </div>

//       <div className="cards">
//         <form className="form" action="">
//           <div className="gap_p">
//             <div className="control_group w_100">
//               <label>Branch Image</label>
//               <div className="upload_box">
//                 <label>
//                   {image && (
//                     <IconButton
//                       className="crossIcon"
//                       onClick={() => setImage("")}
//                     >
//                       <CloseIcon />
//                     </IconButton>
//                   )}
//                   <figure>
//                     <img
//                       src={image ? image : "/static/images/picture.png"}
//                       alt="Upload"
//                     />
//                   </figure>
//                   <IconButton className="uploadIcon">
//                     <label htmlFor="icon-button-file">
//                       <Button component="span" className="upload_image_btn">
//                         <img src="/static/images/edit2_icon.svg" alt="Upload" />
//                         <Input
//                           sx={{ display: "none" }}
//                           id="icon-button-file"
//                           type="file"
//                           inputProps={{
//                             accept: "image/png,image/jpeg",
//                           }}
//                           onChange={(e: any) => {
//                             handleImageUpload(e);
//                             e.target.value = null;
//                           }}
//                         />
//                       </Button>
//                     </label>
//                   </IconButton>
//                 </label>
//               </div>
//             </div>

//             <div className="control_group w_50">
//               <label>Branch Name</label>
//               <TextField
//                 variant="outlined"
//                 placeholder="Branch Name"
//                 fullWidth
//                 hiddenLabel
//               />
//             </div>
//             <div className="control_group w_50">
//               <label>Branch Address</label>
//               <TextField
//                 variant="outlined"
//                 placeholder="Branch Address"
//                 fullWidth
//                 hiddenLabel
//               />
//             </div>
//           </div>

//           <div className="form_end_btn">
//             <Button
//               className="btn btn_secondary"
//               onClick={() => navigate("/manage-branches")}
//             >
//               Submit
//             </Button>
//           </div>
//         </form>
//       </div>
//     </MainContainer>
//   );
// };

// export default AddBranch;

import { useNavigate, useParams } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import MainContainer from "../../layout/MainContainer";
import {
  Button,
  IconButton,
  Input,
  InputAdornment,
  TextField,
} from "@mui/material";
import { useState } from "react";

const AddBranch = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [image, setImage] = useState("");
  const [documents, setDocuments] = useState<{ [key: string]: string }>({
    tradeLicense: "",
    memorandum: "",
    emiratesIdPartner1: "",
    emiratesIdPartner2: "",
    ijari: "",
  });

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setImage("");
      return;
    }

    // Generate a temporary URL for preview
    const imageUrl = URL.createObjectURL(file);
    setImage(imageUrl);
  };

  const handleFileUpload = (
    event: React.ChangeEvent<HTMLInputElement>,
    key: string
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setDocuments((prev) => ({ ...prev, [key]: "" }));
      return;
    }

    // Only allow PDF files
    if (file.type !== "application/pdf") {
      alert("Only PDF files are allowed.");
      return;
    }

    const fileUrl = URL.createObjectURL(file);
    setDocuments((prev) => ({ ...prev, [key]: fileUrl }));
  };

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1>{id ? "Edit" : "Add"} Branch</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/manage-branches")}>Branches</span> -{" "}
            {id ? "Edit" : "Add"} Branch
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_blue" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <form className="form" action="">
          <div className="gap_p">
            {/* Branch Image Upload */}
            <div className="control_group w_100">
              <label>Branch Image</label>
              <div className="upload_box">
                <label>
                  {image && (
                    <IconButton
                      className="crossIcon"
                      onClick={() => setImage("")}
                    >
                      <CloseIcon />
                    </IconButton>
                  )}
                  <figure>
                    <img
                      src={image || "/static/images/picture.png"}
                      alt="Upload"
                    />
                  </figure>
                  <IconButton className="uploadIcon">
                    <label htmlFor="branch-image">
                      <Button component="span" className="upload_image_btn">
                        <img src="/static/images/edit2_icon.svg" alt="Upload" />
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file"
                          type="file"
                          inputProps={{
                            accept: "image/png,image/jpeg",
                          }}
                          onChange={(e: any) => {
                            handleImageUpload(e);
                            e.target.value = null;
                          }}
                        />
                      </Button>
                    </label>
                  </IconButton>
                </label>
              </div>
            </div>

            {/* Branch Name & Address */}
            <div className="control_group w_50">
              <label>Branch Name</label>
              <TextField
                variant="outlined"
                placeholder="Branch Name"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Branch Address</label>
              <TextField
                variant="outlined"
                placeholder="Branch Address"
                fullWidth
                hiddenLabel
              />
            </div>

            {/* Document Uploads */}
            {[
              { key: "tradeLicense", label: "Trade License" },
              { key: "memorandum", label: "Memorandum" },
              { key: "emiratesIdPartner1", label: "Emirates ID Partner 1" },
              { key: "emiratesIdPartner2", label: "Emirates ID Partner 2" },
              { key: "ijari", label: "Ijari" },
            ].map(({ key, label }) => (
              <div className="control_group w_50" key={key}>
                <label>{label} (PDF)</label>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="No file chosen"
                    value={
                      documents[key] ? documents[key].split("/").pop() : ""
                    }
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment className="eye_btn" position="end">
                          <label htmlFor={key}>
                            <Button
                              component="span"
                              className="upload_image_btn"
                            >
                              <img
                                src="/static/images/upload_icon.svg"
                                alt="Upload"
                              />
                            </Button>
                          </label>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Input
                    sx={{ display: "none" }}
                    id={key}
                    type="file"
                    inputProps={{ accept: "application/pdf" }}
                    onChange={(e: any) => {
                      handleFileUpload(e, key);
                      e.target.value = null;
                    }}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="form_end_btn">
            <Button
              className="btn btn_secondary"
              onClick={() => navigate("/manage-branches")}
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default AddBranch;
